// Build version stamp. The value is injected at build time via Vite `define`
// (__APP_VERSION__), sourced from Cloudflare Pages env (CF_PAGES_COMMIT_SHA /
// CF_PAGES_BRANCH) with a git fallback — see vite.config.ts.
interface VersionStampProps {
  // `fixed`: pin to the bottom of the viewport (out of normal flow). Use on
  // login/entry screens and portal footers so the stamp can never be laid out
  // beside centred content or clipped off-screen. Leave off for in-flow use
  // (e.g. the end of a scrollable Settings page).
  fixed?: boolean;
  className?: string;
}

export const VersionStamp = ({ fixed = false, className = "" }: VersionStampProps) => {
  const base = "text-[10px] leading-none text-neutral-400/80 select-none";
  const layout = fixed
    ? "fixed inset-x-0 bottom-0 z-50 pointer-events-none text-center"
    : "block text-center opacity-70";
  return (
    <div
      data-agxl-version={__APP_VERSION__.commit}
      className={`${base} ${layout} ${className}`.trim()}
      style={fixed ? { paddingBottom: "max(env(safe-area-inset-bottom), 0.25rem)" } : undefined}
    >
      {__APP_VERSION__.human}
    </div>
  );
};
